import { createBenefitsQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useBenefitsQuery = createBenefitsQuery(HTTP_CONFIG.API.Optimizely.url)
